import { Box, BoxProps, Button, Divider, Grid, Stack, Typography } from "@mui/material";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { useState } from "react";
import { IDetalharPrescricao } from "../../../../../../../types/api/receituarioAgronomico/detalhar-prescricoes";
import { DadosTitulosItems } from "../../index";
import DialogEditarDadosPrincipais from "./EditarDadosPrincipais";
import DisplayContadores from "../../../../../../../components/DisplayContadores";
import DialogEditarDosagemAplicacao from "./EditarDosagemAplicacao";
import { usePermission } from "../../../../../../../components/PermissionGuard";

interface CardDadosPrescricaoProps {
    boxStyle?: BoxProps;
    detalhe: IDetalharPrescricao;
    onSubmitStep: (payload: any) => void;
    isEditing?: boolean;
}

export default function DadosPrincipais({ boxStyle, detalhe, isEditing, onSubmitStep }: CardDadosPrescricaoProps) {
    const [openEditModal, setOpenEditModal] = useState(false);
    const [openEditDosagemModal, setOpenEditDosagemModal] = useState(false);

    const podeEditar = usePermission('receituario.editar-prescricao');
    const prescricao = detalhe;

    //funções manipuladoras
    const handleOpenEditModal = () => setOpenEditModal(true);
    const handleCloseEditModal = () => setOpenEditModal(false);
    const handleOpenEditDosagemModal = () => setOpenEditDosagemModal(true);
    const handleCloseEditDosagemModal = () => setOpenEditDosagemModal(false);

    return (
        <Box {...boxStyle}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Typography variant="h6">Dados principais</Typography>
            </Stack>
            <Grid container spacing={2}>
                <Grid size={{xs: 12, sm: 6}}>
                    <DadosTitulosItems titulo="Formulação" valor={detalhe?.formulacao ?? "-"} />
                </Grid>
                <Grid size={{xs: 12, sm: 6}}>
                    <DadosTitulosItems titulo="Concentração" valor={detalhe?.concentracao ?? "-"} />
                </Grid>
                <Grid size={{xs: 12, sm: 6}}>
                    <DadosTitulosItems titulo="Cultura" valor={detalhe?.cultura?.nome ?? "-"} />
                </Grid>
                <Grid size={{xs: 12, sm: 6, md: 3}}>
                    <DadosTitulosItems titulo="Agrotóxico" valor={detalhe?.agrotoxico?.marca_comercial ?? "-"} />
                </Grid>
            </Grid>

            {podeEditar && (
                <Stack direction="row" justifyContent="flex-end">
                    <Button
                        variant="contained"
                        size="small"
                        startIcon={<EditOutlinedIcon />}
                        sx={{ fontSize: '0.75rem' }}
                        onClick={handleOpenEditModal}
                    >
                        Editar
                    </Button>
                </Stack>
            )}

            <Divider sx={{ my: 1 }} />

            <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Typography variant="h6">Dosagem e aplicação</Typography>
            </Stack>

            <DisplayContadores fontWeightValue="bold" marginY={0} fontSize="medium" titulo="Qtd. dose" valor={`${prescricao.quantidade_dose ?? "-"} ${unidadeNomeCompleto(prescricao.unidade_dose) ?? "-"}`} />
            <DisplayContadores fontWeightValue="bold" marginY={0} fontSize="medium" titulo="Tamanho" valor={`${prescricao.tamanho_area ?? "-"}`} />
            <DisplayContadores fontWeightValue="bold" marginY={0} fontSize="medium" titulo="Unidade área" valor={`${unidadeareaCompleto(prescricao.unidade_area) ?? "-"}`} />
            <DisplayContadores fontWeightValue="bold" marginY={0} fontSize="medium" titulo="Qtd. aplicações" valor={`${prescricao.quantidade_aplicacoes ?? "-"}`} />
            <DisplayContadores fontWeightValue="bold" marginY={0} fontSize="medium" titulo="Dias intervalo aplicações" valor={`${prescricao.dias_intervalo_aplicacoes ?? "-"}`} />
            <DisplayContadores fontWeightValue="bold" marginY={0} fontSize="medium" titulo="Dias carência" valor={`${prescricao.dias_carencia ?? "-"}`} />

            {podeEditar && (
                <Stack direction="row" justifyContent="flex-end">
                    <Button
                        variant="contained"
                        size="small"
                        startIcon={<EditOutlinedIcon />}
                        sx={{ fontSize: '0.75rem' }}
                        onClick={handleOpenEditDosagemModal}
                    >
                        Editar
                    </Button>
                </Stack>
            )}

            {openEditModal && (
                <DialogEditarDadosPrincipais
                    open={openEditModal}
                    onClose={handleCloseEditModal}
                    isEditing={isEditing ?? false}
                    handleFormSubmit={(data) => {
                        onSubmitStep(data)
                        handleCloseEditModal()
                    }}
                />
            )}
            {openEditDosagemModal && (
                <DialogEditarDosagemAplicacao
                    open={openEditDosagemModal}
                    onClose={handleCloseEditDosagemModal}
                    isEditing={isEditing ?? false}
                    handleFormSubmit={(data) => {
                        onSubmitStep(data)
                        handleCloseEditDosagemModal()
                    }}
                />
            )}
        </Box>  
    );
}

function unidadeareaCompleto(sigla: string): string {
    const mapa: Record<string, string> = {
        HA: "Hectares",
        KG: "Quilogramas",
        KGS: "Quilogramas",
        L: "Litros",
        LA: "Litros",
        LT: "Litros",
        mt2: "Metros quadrados",
        mt3: "Metros cúbicos",
        PL: "PL",
        T: "Toneladas",
        UN: "Unidades"
    };
    return mapa[sigla] ?? sigla;
}

function unidadeNomeCompleto(sigla: string): string {
    const mapa: Record<string, string> = {
        LT: "LITROS",
        GRA: "GRAMAS",
        ML: "MILILITROS",
        KG: "QUILOGRAMAS",
        UN: "UNIDADE",
        HA: "HECTARE",
        ha: "HECTARE",
        PCT: "PACOTE",
        L: "LITROS"
    };
    return mapa[sigla] ?? sigla;
}